import { render, staticRenderFns } from "./AppointmentErrorPage.vue?vue&type=template&id=2dc253ae&"
import script from "./AppointmentErrorPage.vue?vue&type=script&lang=js&"
export * from "./AppointmentErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc253ae')) {
      api.createRecord('2dc253ae', component.options)
    } else {
      api.reload('2dc253ae', component.options)
    }
    module.hot.accept("./AppointmentErrorPage.vue?vue&type=template&id=2dc253ae&", function () {
      api.rerender('2dc253ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/AppointmentErrorPage.vue"
export default component.exports